import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Images, ArrowRight } from "lucide-react";
import { GalleryCard } from "@/pages/Galeria";
import { api } from "@/lib/api";

export default function GalleryTeaser() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/gallery?limit=3").then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, []);

  if (!items || !items.length) return null;

  return (
    <section className="bg-ink-2 py-20 md:py-28 border-t border-white/10" data-testid="home-gallery-teaser">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <div className="inline-flex items-center gap-2 text-gold font-mono2 uppercase tracking-[0.3em] text-xs mb-4">
              <Images className="w-4 h-4" /> Galéria vizualizácií
            </div>
            <h2 className="font-display text-4xl md:text-6xl text-white leading-[0.95]">
              Takto to vyzerá<br /><span className="text-gold">u našich zákazníkov</span>
            </h2>
          </div>
          <Link to="/galeria" data-testid="home-gallery-link"
            className="shrink-0 inline-flex items-center gap-2 border border-gold/50 text-gold px-6 py-3 font-bold uppercase tracking-wider text-sm hover:bg-gold hover:text-ink transition-colors">
            Celá galéria <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-testid="home-gallery-grid">
          {items.map((v, i) => <GalleryCard key={v.id} v={v} index={i} />)}
        </div>
      </div>
    </section>
  );
}
